import { Link } from 'react-router-dom'

import copyJson from '../../demo/fixtures/copy.json'
import type { AnalyticsSummaryItem } from '../../demo/types'
import { Card, GlossaryText } from '../../ui'
import styles from './PeriodSummary.module.css'

interface PeriodSummaryProps {
  items: AnalyticsSummaryItem[]
  highlightedMarker: number | null
  onItemHover: (marker: number | null) => void
}

export function PeriodSummary({ items, highlightedMarker, onItemHover }: PeriodSummaryProps) {
  const dynamicItem = items.find((item) => item.dynamic)

  return (
    <Card className={styles.card} data-scope="analytics-summary">
      <h3 className={styles.title}>{copyJson.labels.periodSummary}</h3>
      <ul className={styles.list}>
        {items.map((item) => (
          <li
            className={`${styles.item} ${highlightedMarker === item.n ? styles.highlighted : ''}`}
            key={item.n}
            onMouseEnter={() => onItemHover(item.n)}
            onMouseLeave={() => onItemHover(null)}
          >
            <span className={styles.number}>{item.n}</span>
            <span className={styles.text}><GlossaryText text={item.text} /></span>
          </li>
        ))}
      </ul>
      {dynamicItem?.linkText && dynamicItem.linkTo ? (
        <p className={styles.linkRow}><Link to={dynamicItem.linkTo}>{dynamicItem.linkText}</Link></p>
      ) : null}
    </Card>
  )
}
